import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 0 40px;
`;

const StyledDonateItemsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;
`;

export { StyledContainer, StyledDonateItemsContainer };
